<!-- 推荐提纲 -->
<template>
<div class="ouline">
    <h4>关键词</h4>
    <div class="inputbox">
        <input type="text" name="" id="keyVal" maxlength="20" placeholder="添加你想添加的关键词" />
        <button @click="addKeyword()">添加</button>
    </div>
    <div style="display: flex; flex-wrap: wrap">
        <el-tag :key="index" v-for="(tag, index) in keywords" size="small" :disable-transitions="false">
            <span @click="getText" :title="tag">{{ tag }} </span><i @click="handleClose(index)" class="el-icon-close xxx"></i>
        </el-tag>
    </div>

    <div class="row">
        <h4>提纲推荐</h4>
        <button @click="getOutline()">
            <i class="el-icon-refresh-right"></i>换一换
        </button>
    </div>
    <div class="list">
        <ul class="outline" v-for="(item, index) in outline" :style="acvtext == index ? 'height: auto;border-color: #06c;' : ''" :key="index" @click="look(index)">
            <li v-for="(items, i) in item.outline" :key="i">
                <h1>第{{ num[i] }}章 {{ items.title }}</h1>
                <ol>
                    <li v-for="(row, j) in items.children" :key="j">
                        <h2>{{ i + 1 }}.{{ j + 1 }} {{ row.title }}</h2>
                    </li>
                </ol>
            </li>
            <el-tooltip content="使用提纲" placement="top">
                <button class="arrow" @click.stop="addouline(item.outline)">
                    <i class="el-icon-arrow-right"></i>
                </button>
            </el-tooltip>
        </ul>
    </div>
</div>
</template>

<script>
export default {
    props: ["title", "outline", "keywords"],
    data: function () {
        return {
            acvtext: -1,
            dynamicTags: [
                "标签标签标签标签",
                "标签标签标签标签",
                "标签标签标签标签",
                "标签一标签标签标签",
                "标签二标签标签",
                "标签三标签标签标签",
            ],
            num: [
                "一",
                "二",
                "三",
                "四",
                "五",
                "六",
                "七",
                "八",
                "九",
                "十",
                "十一",
                "十二",
                "十三",
                "十四",
                "十五",
                "十六",
                "十七",
                "十八",
                "十九",
                "二十",
            ],
        };
    },
    components: {},
    mounted: function () {},
    methods: {
        look: function (index) {
            console.log(index);
            if (this.acvtext != index) {
                this.acvtext = index;
            } else {
                this.acvtext = -1;
            }
        },

        addouline: function (item, event) {
            if (!this.$root.stateType.isLogin) {
                this.$message({
                    message: "此功能登录才能使用",
                    type: "warning",
                });
                return false;
            }
            let div = document.createElement("div");
            item.forEach((item, i) => {
                let h1 = document.createElement("h1");
                h1.innerHTML = "第" + this.num[i] + "章 " + item.title;
                div.appendChild(h1);
                let children = item.children;
                children.forEach((items, j) => {
                    let h2 = document.createElement("h2");
                    h2.innerHTML = i + 1 + "." + j + 1 + " " + items.title;
                    div.appendChild(h2);
                });
            });
            document.getElementById("editor").innerHTML =
                div.innerHTML + document.getElementById("editor").innerHTML;
            this.$emit("saveOutline", "true");
            return false;
        },
        addKeyword: function () {
            let keyWord = document.getElementById("keyVal").value.trim();
            if (
                this.keywords.length < 10 &&
                keyWord.length > 0
            ) {
                this.keywords.push(keyWord);
                document.getElementById("keyVal").value = "";
            } else if(this.keywords.length >= 10){
                this.$message({
                    message: "最多只能输入10个关键词",
                    type: "warning"
                })
            } else if (keyWord.length == 0) {
                this.$message({
                    message: "请添加关键词",
                    type: "warning"
                })
            }
        },
        handleClose: function (index) {
            this.keywords.splice(index, 1);
        },
        getOutline: function () {
            if (!this.$root.stateType.isLogin) {
                this.activeName = 1;
                this.$message({
                    message: "此功能登录才能使用",
                    type: "warning",
                });
                return false;
            }
            this.$emit("getOutline", "true");
        },

        getText: function (item) {
            console.log(item);
        },
    },
};
</script>

<style lang="scss" scoped>
.ouline {
    h4 {
        margin-top: 40px;
        font-size: 16px;
        font-weight: bold;
        color: #34343a;
    }

    .outline {
        height: 300px;
        overflow: hidden;
    }

    .inputbox {
        width: 290px;
        height: 32px;
        border-radius: 32px;
        border: 1px solid #cccccc;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        padding-left: 14px;
        margin-top: 16px;

        input {
            width: 100%;
            border: none;
        }

        button {
            min-width: 56px;
            height: 34px;
            border-top-right-radius: 16px;
            border-bottom-right-radius: 16px;
            background: $btnc;
            color: #ffffff;
        }
    }

    .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 40px;

        h4 {
            margin-top: 0;
        }

        button {
            background: none;
            color: #989ea2;
            border: none;
        }

        button:hover {
            color: $btnc;
        }
    }

    .list {
        margin-top: 24px;
        height: 60vh;
        overflow: auto;
        width: 306px;
        padding-right: 12px;

        ul {
            padding: 0;
            position: relative;
            border: 1px solid #f5f6fa;
            border-radius: 4px;
            padding: 20px;
            margin-bottom: 16px;
            cursor: pointer;

            ol {
                padding: 0;

                li {
                    margin-top: 15px;
                }
            }

            li+li {
                margin-top: 15px;
            }

            h1 {
                font-size: 14px;
                font-weight: 400;
                color: #34343a;
            }

            h2 {
                font-size: 14px;
                font-weight: 400;
                color: #66686e;
                padding-left: 12px;
            }

            .arrow {
                position: absolute;
                width: 32px;
                height: 32px;
                border-radius: 32px;
                bottom: 12px;
                right: 20px;
                box-shadow: 0px 0px 5px 0px rgba(86, 118, 189, 0.2);
                background: #ffffff;
                color: $btnc;
                border: none;
                font-weight: bold;
            }

            .arrow:hover {
                background: $btnc;
                color: #ffffff;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/writing/ouline.vue